import { Pipe, PipeTransform } from '@angular/core';
import { PlanFinalPrice } from 'src/app/core/proto/reconciliator/plans/interfaces';
import { UtilsService } from 'src/app/core/services/utils.service';

@Pipe({
  name: 'finalPricesRange'
})
export class FinalPricesRangePipe implements PipeTransform {

  constructor(private _utilsService: UtilsService) { }

  transform(finalPrices: PlanFinalPrice[]): string {
    if (finalPrices === undefined) return '';

    const monetaryCurrency = finalPrices.filter(finalPrice => finalPrice.currency === 'MXN');
    const pointsCurrency = finalPrices.find(finalPrice => finalPrice.currency === 'PTS');
    let output = '';

    if (monetaryCurrency.length > 0) {
      monetaryCurrency.sort((a, b) => (a.finalPrice > b.finalPrice) ? 1 : -1);

      const smallestAmount = monetaryCurrency[0];
      const highestAmount = monetaryCurrency[monetaryCurrency.length - 1];

      if (smallestAmount && highestAmount) {
        output += this._utilsService.convertToDollars(smallestAmount.finalPrice);

        if (smallestAmount.finalPrice !== highestAmount.finalPrice) {
          output += `-${this._utilsService.convertToDollars(highestAmount.finalPrice)}`;
        }
      }

      output += ` ${smallestAmount.currency}`;
    }

    if (pointsCurrency) {
      if (monetaryCurrency.length > 0) output += ', ';
      output += `${this._utilsService.convertToDollars(pointsCurrency.finalPrice)} ${pointsCurrency.currency}`;
    }

    return output;
  }

}
